import styled from 'styled-components'
import TutorialTabs from './TutorialTabs/tutorialtabs'
import { useTranslation } from 'react-i18next'
import { adobeInteractionEvent } from 'utils/adobewa'

const BoxContainer = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    width: 359px;
    height: 1350px;
    padding: 32px 20px;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
`

const TitleUnderLine = styled.div`
    margin-top: 16px;
    width: 59px;
    height: 5px;
    background: #d9c277;
`

const WinsOfApp = styled.div`
    padding-top: 48px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
`

const VideoAreaContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: center;
    justify-content: center;
`

const VideoArea = styled.div`
    width: 316px;
    height: 193px;
    margin-top: 40px;
`

const TutorialTabsContainer = styled.div`
    margin-top: 40px;
    overflow-x: scroll;
    width: 319px;
    min-height: 856px;
`

export default function Tutorial() {
    const { t, i18n } = useTranslation('', {
        keyPrefix: 'spendwins.tutorial',
    })
    const lang = i18n.language

    const videoOnplay = (url: string) => {
        adobeInteractionEvent({
            lang: lang,
            eventID: `prioritysite_clickPlayVideo_SpendWins_WinsOn3in1_Video`,
            videoFileName: url,
        })
    }

    return (
        <BoxContainer>
            <TitleContainer>
                <TitleText>{t(`title`)}</TitleText>
                <TitleUnderLine />
            </TitleContainer>
            <TutorialTabsContainer>
                <TutorialTabs />
            </TutorialTabsContainer>
            <WinsOfApp>
                <TitleContainer>
                    <TitleText>{t(`secondTitle`)}</TitleText>
                    <TitleUnderLine />
                </TitleContainer>
                <VideoAreaContainer>
                    <VideoArea>
                        <video
                            title="tutorial of spend wins"
                            controls
                            style={{
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%',
                                borderRadius: '25px',
                            }}
                            src={t(`video`)}
                            onPlay={() => {
                                videoOnplay(t(`video`))
                            }}
                        />
                    </VideoArea>
                </VideoAreaContainer>
            </WinsOfApp>
        </BoxContainer>
    )
}
